const { formatSmsInboxStamp } = require('./smsInbox');

const SMS_INBOUND_POPUP_DISMISS_KEY = 'smsInboundPopupDismissedId';

function readDismissedSmsPopupId(storage) {
  try {
    if (!storage || typeof storage.getItem !== 'function') return null;
    const id = Number(storage.getItem(SMS_INBOUND_POPUP_DISMISS_KEY));
    return Number.isFinite(id) && id > 0 ? id : null;
  } catch (err) {
    return null;
  }
}

function rememberDismissedSmsPopup(storage, messageId) {
  const id = Number(messageId);
  if (!storage || typeof storage.setItem !== 'function') return;
  if (!Number.isFinite(id) || id <= 0) return;
  try {
    storage.setItem(SMS_INBOUND_POPUP_DISMISS_KEY, String(id));
  } catch (err) {
    /* private mode can refuse storage */
  }
}

function smsInboundPopupFromPayload(payload) {
  if (!payload || typeof payload !== 'object') return null;
  const rawId = payload.latestId != null ? payload.latestId : payload.id;
  const id = Number(rawId);
  if (!Number.isFinite(id) || id <= 0) return null;
  const sender = String(payload.fromName || payload.sender || 'SMS').trim() || 'SMS';
  const bodyMissing = payload.body == null;
  const rawBody = bodyMissing ? '' : String(payload.body);
  return {
    id,
    sender,
    body: bodyMissing ? '' : rawBody.trim() ? rawBody : 'Photo',
    createdAt: payload.createdAt || null,
    time: formatSmsInboxStamp(payload.createdAt, true),
  };
}

function shouldShowSmsInboundPopup({
  inboxOpen = false,
  staffDialogOpen = false,
  badgeCount = 0,
  messageId,
  dismissedId,
} = {}) {
  const id = Number(messageId);
  if (inboxOpen || staffDialogOpen) return false;
  if (!(Number(badgeCount) > 0)) return false;
  if (!Number.isFinite(id) || id <= 0) return false;
  if (dismissedId != null && Number(dismissedId) === id) return false;
  return true;
}

module.exports = {
  SMS_INBOUND_POPUP_DISMISS_KEY,
  readDismissedSmsPopupId,
  rememberDismissedSmsPopup,
  smsInboundPopupFromPayload,
  shouldShowSmsInboundPopup,
};
